export default {
    egateeUserCenter: "Egatee အသုံးပြုသူစင်တာ",
    mayTheForceBeWithU: "ခွန်အားတွေ မင်းနဲ့အတူရှိပါစေ။",
    egatee: "Egatee",
    jde: "Jde",
    egateeShopCenter: "Egatee ဆိုင်စင်တာ",
    egateeGlobalCommandCenter: "Egatee Global Command Center",
    egateeCountrySite: "Egatee နိုင်ငံဆိုက်",
    shopCenter: "ဆိုင်စင်တာ",
    globalCommandCenter: "Global Command Center",
    countrySite: "နိုင်ငံအလိုက်ဆိုဒ်",
    suppliersSettled: "ဆိုင်အတည်တကျ",
    supplierInformation: "ဆိုင်အချက်အလက်",
    subjectInformation: "ဘာသာရပ်ဆိုင်ရာအချက်အလက်များ",
    mmdc: "MMDC",
    mmdc_title: "MMDC-ဒေတာ"
}